"use client";
import { useEffect, useState } from 'react';

const SHORTCUT_HINT_HIDDEN_KEY = 'shortcuts.hint.hidden';
const SHORTCUT_HINT_DISMISSED_KEY = 'shortcuts.hint.dismissed';

function isShortcutHintDismissed() {
  try {
    return (
      localStorage.getItem(SHORTCUT_HINT_DISMISSED_KEY) === '1' ||
      localStorage.getItem(SHORTCUT_HINT_HIDDEN_KEY) === '1'
    );
  } catch {
    return true;
  }
}

export default function ShortcutHint() {
  const [ready, setReady] = useState(false);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    setHidden(isShortcutHintDismissed());
    setReady(true);
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(SHORTCUT_HINT_DISMISSED_KEY, '1');
      localStorage.setItem(SHORTCUT_HINT_HIDDEN_KEY, '1');
    } catch {}
    setHidden(true);
  };

  if (!ready || hidden) return null;

  return (
    <div className="fixed bottom-3 right-3 z-40 hidden rounded-lg border border-border bg-background/90 px-3 py-2 text-xs text-muted-foreground shadow lg:block">
      Shortcuts: ? • f • j • n
      <button
        className="ml-2 text-muted-foreground/70 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        onClick={dismiss}
        aria-label="Hide shortcuts hint"
      >
        ×
      </button>
    </div>
  );
}
